import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
export default function Introduction() {
  return <section id="introduktion" className="relative w-full bg-background py-24 flex flex-col items-center justify-center">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-3xl">
        <Badge variant="default" className="mb-6 uppercase tracking-wider text-xs px-3 py-1">
          Legal
        </Badge>
        
        <h1 className="text-4xl md:text-[48px] font-serif text-foreground mb-6 leading-tight tracking-tight">
          Integritetspolicy
        </h1>
        
        <p className="text-lg font-sans text-muted-foreground leading-relaxed">
          Denna domän ägs och drivs av Mirago Media AB. Vi värnar om din personliga integritet och strävar efter att alltid skydda dina personuppgifter på ett säkert och ansvarsfullt sätt.
        </p>
      </div>

      <Separator className="absolute bottom-0 left-0 w-full" />
    </section>;
}